import dateFns from 'date-fns';
import _ from 'lodash';
import { fiflboxApi } from '@/utils/api';

const state = {
  blockings: {}
};

const getters = {
  getBlockings: state => {
    return state.blockings;
  },
  getBlockingsByDates: state => dates => {
    return dates.map(date => {
      return state.blockings[dateFns.format(date, 'YYYY-MM-DD')] || [];
    });
  }
};

const actions = {
  async syncBlockings({ commit }, range) {
    try {
      const { data: blockings } = await fiflboxApi.v1.getBookingBlockings({
        dt_after: dateFns.startOfDay(range.start),
        dt_before: dateFns.endOfDay(range.end)
      });
      const blockingByDates = {};

      blockings.forEach(blocking => {
        const dateString = new Date(blocking.start).toDateFormat();

        if (blockingByDates[dateString]) {
          return blockingByDates[dateString].push(blocking);
        }

        blockingByDates[dateString] = [blocking];
      });

      commit('setBlockings', blockingByDates);
    } catch (err) {
      console.log(err);
    }
  },
  async syncBlocking({ commit }, targetDate) {
    try {
      const { data: blockings } = await fiflboxApi.v1.getBookingBlockings({
        dt_after: dateFns.startOfDay(targetDate),
        dt_before: dateFns.endOfDay(targetDate)
      });
      const blockingByDates = {};
      if (blockings.length) {
        blockingByDates[dateFns.format(targetDate, 'YYYY-MM-DD')] = [];
        blockings.forEach(blocking => {
          const dateString = new Date(blocking.start).toDateFormat();

          if (blockingByDates[dateString]) {
            return blockingByDates[dateString].push(blocking);
          }

          blockingByDates[dateString] = [blocking];
        });
      } else {
        delete state.blockings[dateFns.format(targetDate, 'YYYY-MM-DD')];
      }
      commit('setBlockings', blockingByDates);
    } catch (err) {
      console.log(err);
    }
  }
};

const mutations = {
  async setBlockings(state, blockingByDates) {
    state.blockings = {
      ...state.blockings,
      ...blockingByDates
    };
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
